import type { FC } from "react";

import { Button, Icon, Text, toastSuccess } from "@alpacahq/ui/old";

export const IncomingWireInstructions: FC<{ accountNumber: string }> = ({
  accountNumber,
}) => {
  const fields = {
    "Bank Name": "BMO HARRIS BANK NA",
    "Bank Address": "111 W. Monroe Street Chicago, IL 60603",
    "Account Name": "Alpaca Securities LLC",
    "ABA Routing Number": "071 000 288",
    "Swift Code": "HATRUS44",
    "Account Number": "1636877",
    "Special Instructions": `FFC LPCA-${accountNumber}`,
  };

  const allInstructions = Object.entries(fields)
    .map(([key, value]) => `${key}: ${value.toString()}`)
    .join("\n");

  const onCopyClicked = (text: string) => async () => {
    await navigator.clipboard.writeText(text);

    toastSuccess("Copied to clipboard");
  };

  return (
    <>
      <div className="rounded bg-gray-100 p-4 pb-0">
        {Object.entries(fields).map(([label, value]) => (
          <div className="flex items-center justify-between pb-4" key={label}>
            <div className="">
              <Text className="color-gray-500">{label}</Text>
              <Text className="font-semibold">{value}</Text>
            </div>
            <Button variant="ghost" onClick={onCopyClicked(value)}>
              <Icon name="ClipboardDocumentList" size="sm" />
            </Button>
          </div>
        ))}
      </div>
      <Button
        className="mt-2 ml-auto"
        variant="alternate"
        onClick={onCopyClicked(allInstructions)}
      >
        Copy All Instructions
        <Icon className="ml-2" name="ClipboardDocumentList" />
      </Button>
      <Text className="mt-6">
        Wire transfers may take 2-3 business days. Your bank may charge you for
        outgoing wires.
      </Text>
      <Text className="my-4 font-semibold text-red-700">
        Make sure you include the special instructions field, it contains your
        account number.
      </Text>
      <Text>
        Please contact{" "}
        <a className="underline" href="mailto:support@alpaca.markets">
          support@alpaca.markets
        </a>{" "}
        if you do not see your wire deposit in your account after: 2 business
        days for Domestic (US) wires or 5 business days for SWIFT
        (international) wires.
      </Text>
    </>
  );
};
